module.exports = __webpack_public_path__ + "static/media/background_logo.43334255.PNG";